import { render, staticRenderFns } from "./StarrySkyCanvas.vue?vue&type=template&id=3041a538&scoped=true&"
import script from "./StarrySkyCanvas.vue?vue&type=script&lang=js&"
export * from "./StarrySkyCanvas.vue?vue&type=script&lang=js&"
import style0 from "./StarrySkyCanvas.vue?vue&type=style&index=0&id=3041a538&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041a538",
  null
  
)

component.options.__file = "StarrySkyCanvas.vue"
export default component.exports